import { Amplify } from "aws-amplify";
import awsconfig from "../../aws-exports";
import { withAuthenticator } from '@aws-amplify/ui-react';
import { AmplifyAuthenticator } from './../parts/Parts';
import { DefaultHeader } from "./../parts/Parts";

Amplify.configure(awsconfig);

export const AuthAccess = () => {
    return (
        <>
            <DefaultHeader defaultHeader="Auth Access" />
            <div className="component auth-access-component">
                <div className="row auth-access--one">
                    <div className="col col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <AmplifyAuthenticator />
                    </div>
                </div>
            </div>
        </>
    );
};

export default withAuthenticator(AuthAccess);
